import ApplicationSerializer from 'eflex/serializers/application';

export default class ComponentSerializer extends ApplicationSerializer {
  attrs = {
    bomSource: {
      serialize: false,
      deserialize: false,
    },
    tasks: {
      serialize: false,
      deserialize: false,
    },
    options: {
      embedded: 'always',
    },
  };
}
